import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=2812cd5e&scoped=true"
import script from "./LeftBar.vue?vue&type=script&lang=js"
export * from "./LeftBar.vue?vue&type=script&lang=js"
import style0 from "./LeftBar.vue?vue&type=style&index=0&id=2812cd5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812cd5e",
  null
  
)

export default component.exports